/*
So the issue comes in that cache version (cv) get hardcoded at nuxt server startup,
using this function aligns client & server to use the same cv, with reasonable
3 minute cache time to the storyblok CDN.
see: https://www.storyblok.com/docs/concepts/caching
*/

export function useCachedStoryblok() {
	const total = ref(0);
	const per_page = ref(0);

	const fetchStory = async (urlPath, options) => {
		const queryParams = {
			path: urlPath,
			...options
		}
		const { data: SbData, error } = await useFetch(
			'/sblok',
			{
				query: queryParams,
			  	onResponse({ response }) {
			    	total.value = response.headers.get('total', 0)
			    	per_page.value = response.headers.get('per-page', 0)
			  	}
			}
		)
		if (error.value) {
			console.error('useCachedStoryblok.fetchStory', error.value);
		}
		return {
			data: SbData,
			total: total,
			per_page: per_page,
		}
	}

	const get = async (urlPath, options = {}, cacheKey = null) => {
		const res = await fetchStory(urlPath, options)
		return res
	}

	return {
		total,
		per_page,
		get,
		fetchStory
	}
}
